export default __webpack_public_path__ + "static/media/bsmdidjaxxx-color.170c0e1e.svg";